module.exports = __webpack_public_path__ + "img/6_45.4fafa8da.png";